
import {Radar} from 'vue-chartjs';
import {defineComponent, PropType} from "vue";
import TeethExamPackageDto from "@/dto/TeethExamPackageDto";

export default defineComponent({
    name: 'TeethExam',
    components: {},
    props:{
        currentData: {type: Array as PropType<number[]>, required: true},
        currentLabel: {type: String, required: true},
        currentBorderColor: {type: String, required: true},
        exams: {type: Object as PropType<TeethExamPackageDto>, required: true},
    },
    data(){
        return{

        }
    },
    methods:{
        test(arg: string):boolean{
            console.log(arg)
            return true
        }
    },
    created() {
        console.log(JSON.stringify(this.exams))
    }
});
